import { getComposerDraftReloadSafety } from '@/components/org-chat/composer-input/composer-reload-safety';
import type { ReloadSafety } from './reload-blockers';

const SESSION_DRAFT_PREFIX = 'org-chat-draft:v1:';

export function getStoredSessionDraftNativeReloadSafety(
  raw: string | null,
  outbox = false
): ReloadSafety {
  if (raw === null) return 'safe';
  try {
    const value: unknown = JSON.parse(raw);
    if (
      !value ||
      typeof value !== 'object' ||
      !('version' in value) ||
      value.version !== 1 ||
      !('draft' in value)
    )
      return 'unknown';
    if (outbox)
      return Array.isArray(value.draft)
        ? value.draft.length
          ? 'blocked'
          : 'safe'
        : 'unknown';
    return getComposerDraftReloadSafety(value.draft);
  } catch {
    return 'unknown';
  }
}

/** SessionStorage survives a web reload, but a native restart creates a new session. */
export function getSessionDraftNativeReloadSafety(
  storage: Pick<Storage, 'length' | 'key' | 'getItem'>
): ReloadSafety {
  let unknown = false;
  try {
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (!key?.startsWith(SESSION_DRAFT_PREFIX)) continue;
      const state = getStoredSessionDraftNativeReloadSafety(
        storage.getItem(key),
        key.endsWith(':outbox')
      );
      if (state === 'blocked') return 'blocked';
      if (state === 'unknown') unknown = true;
    }
    return unknown ? 'unknown' : 'safe';
  } catch {
    return 'unknown';
  }
}
